import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import {
    PiFlagBannerBold,
    PiTrophyBold,
    PiStepsBold,
    PiWarningOctagonBold,
    PiLightningBold,
    PiCurrencyDollarBold,
    PiChartLineUpBold,
    PiHandshakeBold,
    PiGlobeHemisphereWestBold,
    PiRocketLaunchBold,
    PiLightbulbBold,
    PiWarningCircleBold
} from "react-icons/pi";
import './MoonshotNode.css';

const MoonshotNode = ({ data, type, selected }) => {

    // Determine if it's a Main Path node or a Sticky Note
    const isMainPath = ['start', 'end', 'milestone'].includes(type);
    const nodeClass = isMainPath ? 'node-main' : 'node-sticky';

    // Determine Icon and Label based on type & data
    const getHeaderInfo = () => {
        switch (type) {
            case 'start': return { icon: <PiCurrencyDollarBold />, label: 'Current State', className: 'type-start' };
            case 'end': return { icon: <PiRocketLaunchBold />, label: 'Moonshot', className: 'type-end' };
            case 'milestone':
                // We can cycle icons based on index/order if available, or generic
                return { icon: <PiChartLineUpBold />, label: 'Milestone', className: 'type-milestone' };
            case 'blocker': return { icon: <PiWarningOctagonBold />, label: 'Blocker', className: 'type-blocker' };
            case 'capability': return { icon: <PiLightningBold />, label: 'Capability', className: 'type-capability' };
            case 'risk': return { icon: <PiWarningCircleBold />, label: 'Risk', className: 'type-risk' };
            case 'idea': return { icon: <PiLightbulbBold />, label: 'Idea', className: 'type-idea' };
            default: return { icon: <PiStepsBold />, label: 'Step', className: 'type-default' };
        }
    };

    const { icon, label, className } = getHeaderInfo();

    return (
        <div className={`moonshot-node ${ nodeClass } ${ className } ${ selected ? 'selected' : '' }`}>
            {/* Input Handle */}
            {type !== 'start' && (
                <Handle
                    type="target"
                    position={isMainPath ? Position.Left : Position.Bottom} // Stickies attach from bottom/top usually
                    id="target"
                />
            )}

            <div className="node-icon-wrapper">
                {icon}
            </div>

            <div className="node-content">
                {isMainPath && <div className="node-type-label">{label}</div>}
                <div className="node-title">{data.label}</div>
            </div>

            {/* Output Handle */}
            {type !== 'end' && (
                <Handle
                    type="source"
                    position={isMainPath ? Position.Right : Position.Top}
                    id="source"
                />
            )}
        </div>
    );
};

export default memo(MoonshotNode);
